import {Injectable} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';

@Injectable()
export class RoleService {

  constructor(private oauthService: OAuthService) {
  }

  hasPriceHistoryRole(): boolean {
    return this.hasRole('price-history');
  }

  private hasRole(role): boolean {
    const resourceAccess = this.getResourceAccess();
    if (this.isPriceHistoryFrontendRoleConfigured(resourceAccess)) {
      return resourceAccess['price-history-frontend']['roles'].some(x => x === role);
    }
    return false;
  }

  private isPriceHistoryFrontendRoleConfigured(resourceAccess) {
    return resourceAccess != null &&
      resourceAccess['price-history-frontend'] != null &&
      resourceAccess['price-history-frontend']['roles'] != null;
  }

  private getResourceAccess(): any {
    if (this.oauthService.hasValidAccessToken()) {
      const token = this.oauthService.getAccessToken();
      // const tokenDecode = jwt_decode(token);
      // return tokenDecode['resource_access'];
    }
    return null;
  }

}
